// extracted by mini-css-extract-plugin
export default {"box":"PreOrderCodeInput_box__Yb0Yq","span":"PreOrderCodeInput_span__1EEIZ","input":"PreOrderCodeInput_input__UZhH1"};